<template>
	<v-row>
		<v-container fluid class="pt-0">
			<EditarItemDialog :dialogQuantidade="dialogEditarItem" :item="item" @fecharDialog="closedialogEditarItem" />
			<EnderecoDialog :dialogEndereco="dialogEndereco" @dialogEnderecoClose="dialogEnderecoClose" />
			<DadosCompraDialog
				:dialogDadosCompra="dialogDadosCompra"
				:tipoEntrega="tipoEntrega"
				:totalCompras="totalCompras"
				@dialogDadosCompraClose="dialogDadosCompraClose"
			/>
			<ExcluirProdutoDialog :dialog="dialogExcluirProduto" :id="id" @dialogClose="dialogExcluirProdutoClose" />
			<v-row justify="center" class="pt-5">
				<v-col md="11" xl="7" class="pt-0">
					<v-row>
						<v-col cols="12" sm="8" md="8" lg="8" class="pt-0 texto--text">
							<div class="ma-0 pa-0">
								<v-row class="ma-0 pa-0">
									<p class="textCarrinho">CARRINHO</p>
									<p class="textCarrinhoQuantidade mx-1">
										({{ cartProducts.length }} Item(s) {{ cartLength }} unidade(s))
									</p>
								</v-row>
								<v-container v-for="i in this.cartProducts" :key="i.uuid" class="ma-0 pa-0" flex>
									<v-row class="mx-0 my-2 pa-0 pb-2">
										<v-col sm="2" md="2" class="pt-0 pb-0">
											<Imagens :imagens="[{ url_img: i.imagem }]" :galeria="false" />
										</v-col>
										<v-col sm="7" md="7" align-self="start" class="pt-0 pb-0">
											<v-container class="ma-o pa-0">
												<v-row class="ma-o pa-0">
													<p class="textDescricaoProduto">{{ i.descricao }}</p>
													<v-spacer />
												</v-row>
												<v-row class="ma-o pa-0">
													Quantidade:
													{{
														parseFloat(i.quantidade).toFixed(2).toString().replace('.', ',')
													}}
												</v-row>
												<v-row class="ma-o pa-0" v-if="i.observacao">
													Observação: {{ i.observacao }}
												</v-row>
											</v-container>
										</v-col>
										<v-col sm="3" md="3" align-self="start" class="pt-0 pb-0">
											<v-row class="ma-1 pa-0" justify="end">
												<p class="textValorItemTitulo mx-1">Vl. Unit.:</p>
												<p class="textValorItem">{{ convertDinheiro(i.valorUnitario) }}</p>
											</v-row>
											<v-row class="ma-1 pa-0" justify="end" v-if="i.valorAdicional">
												<p class="textValorItemTitulo mx-1">Vl. Adc.:</p>
												<p class="textValorItem">
													{{ convertDinheiro(i.valorAdicional / i.quantidade, 2) }}
												</p>
											</v-row>
											<v-row class="ma-1 pa-0" justify="end">
												<p class="textValorItemTitulo mx-1">Vl. Total:</p>
												<p class="textValorItem">{{ convertDinheiro(i.valorTotal, 2) }}</p>
											</v-row>
											<v-row class="ma-0 pa-0" justify="end">
												<v-icon @click="editar(i)" color="texto"> mdi-pencil </v-icon>
												<v-icon
													v-model="i.quantidade"
													@click="dialogExcluirProdutoOpen(i.uuid)"
													color="texto"
												>
													mdi-delete</v-icon
												>
											</v-row>
										</v-col>
									</v-row>
								</v-container>
								<v-row justify="center">
									<v-col cols="12" sm="4" md="4" lg="4">
										<Botao @clicar="adicionarItens()" texto="Adicionar itens" transparente />
									</v-col>
								</v-row>
							</div>
						</v-col>
						<v-col cols="12" sm="4" md="4" lg="4" class="pt-0">
							<Card cinza>
								<p class="textEntrega">ENTREGA</p>
								{{ this.empresa.obsFechamento }}
								<v-radio-group
									v-model="tipoEntrega"
									row
									dense
									class="mt-1 mb-2 pa-0 red--text"
									hide-details=""
								>
									<v-radio
										label="Entrega"
										value="Entrega"
										class="radioButton"
										color="primary"
										v-if="entregar()"
									/>
									<v-radio
										label="Retirada"
										value="Retirar"
										class="radioButton"
										color="primary"
										v-if="retirar()"
									/>
								</v-radio-group>
								<botao
									v-if="this.tipoEntrega == 'Entrega' && !this.endereco.cep"
									@clicar="dialogEnderecoOpen()"
									texto="Adicionar endereço"
									transparente
								/>
								<v-row v-if="this.tipoEntrega == 'Entrega' && this.endereco.cep" class="ma-0 pa-0">
									<v-col cols="10" class="pt-0 pb-0">
										<strong>Endereço:</strong> {{ this.endereco.logradouro }},
										{{ this.endereco.numero }}, {{ this.endereco.bairro }},
										{{ this.endereco.cidade }} -
										{{ this.endereco.uf }}
										{{ this.endereco.cep }}
									</v-col>
									<v-col class="pl-0">
										<v-icon @click="dialogEnderecoOpen()" color="black"> mdi-pencil </v-icon>
										<v-icon @click="deleteEndereco()" color="black"> mdi-delete </v-icon>
									</v-col>
								</v-row>
								<p class="textTotais">TOTAIS</p>
								<v-row class="ma-0 pa-0">
									<p class="textPagamentos">SUB-TOTAL</p>
									<v-spacer />
									<p class="textPagamentos">{{ convertDinheiro(subTotalCompras, 2) }}</p>
								</v-row>
								<v-row class="ma-0 pa-0" v-if="this.tipoEntrega == 'Entrega'">
									<p class="textPagamentos">TAXA DE ENTREGA</p>
									<v-spacer />
									<p class="textPagamentos">
										{{
											this.cartLength > 0
												? convertDinheiro(empresa.valorentrega)
												: convertDinheiro(0)
										}}
									</p>
								</v-row>
								<v-row class="ma-0 pa-0">
									<p class="textPagamentosTotal">TOTAL</p>
									<v-spacer />
									<p class="textPagamentosTotal">{{ convertDinheiro(totalCompras, 2) }}</p>
								</v-row>
								<Botao @clicar="dialogDadosCompraOpen()" texto="Finalizar compra" />
							</Card>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
	</v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnderecoDialog from '../components/Checkout/EnderecoDialog.vue'
import DadosCompraDialog from '../components/Checkout/DadosCompraDialog.vue'
import ExcluirProdutoDialog from '../components/Checkout/ExcluirProdutoDialog.vue'
import Imagens from '../components/shared/Imagens.vue'
import EditarItemDialog from '../components/Produto/EditarItemDialog.vue'
import Card from '../components/shared/Card.vue'
import Botao from '../components/shared/Botao.vue'

export default {
	components: {
		EnderecoDialog,
		DadosCompraDialog,
		ExcluirProdutoDialog,
		Imagens,
		EditarItemDialog,
		Card,
		Botao,
	},
	data: function () {
		return {
			selectionItens: [...Array(100).keys()],
			entrega: 0,
			dialogEndereco: false,
			tipoEntrega: 'Retirar',
			dialogDadosCompra: false,
			dialogQuantidade: false,
			dialogExcluirProduto: false,
			id: '',
			item: {},
			produto: {},
			dialogEditarItem: false,
		}
	},
	methods: {
		...mapActions({
			delToCart: 'delToCart',
			addToCart: 'addToCart',
			addEndereco: 'addEndereco',
			addcadastroProduto: 'addcadastroProduto',
		}),
		changeSelection(item) {
			const cart = { codigo: item.codigo, quantidade: Number(item.quantidade), operacao: 'ALTER_ITEM_CART' }
			if (item.quantidade == 0) {
				this.delItem(item)
			} else {
				this.addToCart(cart)
			}
		},
		changeEntrega(tipoEntrega) {
			const endereco = {
				entrega: tipoEntrega,
				operacao: 'ALTER_ENTREGA',
			}
			this.addEndereco(endereco)
		},
		editar(i) {
			this.item = i

			this.addcadastroProduto(i.cadastroProduto)

			this.abrirDialogEditarItem(i)
		},
		dialogEnderecoOpen() {
			if (this.cartLength > 0) {
				this.dialogEndereco = true
			} else {
				this.$store.dispatch('showError', 'Não existem produtos no carrinho!')
			}
		},
		deleteEndereco() {
			this.addEndereco({})
		},
		dialogEnderecoClose() {
			this.dialogEndereco = false
		},
		adicionarItens() {
			this.$router.push(`/${this.catalogo.identificadorCatalogo}${this.retornarQueryVendedor()}`)
		},
		dialogDadosCompraOpen() {
			if (this.cartLength > 0) {
				if (this.tipoEntrega == 'Entrega' && !this.endereco.cep)
					this.$store.dispatch('showError', 'É necessário informar o endereço para a entrega!')
				else this.dialogDadosCompra = true
			} else {
				this.$store.dispatch('showError', 'Não existem produtos no carrinho!')
			}
		},
		dialogDadosCompraClose() {
			this.dialogDadosCompra = false
		},
		abrirDialogEditarItem(i) {
			this.item = i
			this.dialogEditarItem = true
		},
		closedialogEditarItem() {
			this.item = {}
			this.dialogQuantidade = false
			this.dialogEditarItem = false
		},
		dialogExcluirProdutoOpen(id) {
			this.id = id
			this.dialogExcluirProduto = true
		},
		dialogExcluirProdutoClose() {
			this.dialogExcluirProduto = false
		},
		retirar() {
			return this.empresa.tipoEntrega == 'R' || this.empresa.tipoEntrega == 'X' ? true : false
		},
		entregar() {
			if (this.empresa.tipoEntrega == 'E') this.tipoEntrega = 'Entrega'
			return this.empresa.tipoEntrega == 'E' || this.empresa.tipoEntrega == 'X' ? true : false
		},
	},
	computed: {
		...mapGetters({
			cartProducts: 'cartProducts',
			cartLength: 'cartLength',
			empresa: 'empresa',
			catalogo: 'catalogo',
			endereco: 'endereco',
		}),
		subTotalCompras() {
			var ret = 0.0
			this.cartProducts.map((i) => {
				ret += i.valorTotal
			})
			return ret //ret.toFixed(2).toString().replace('.', ',')
		},
		totalCompras() {
			var ret = 0.0
			if (this.tipoEntrega == 'Entrega' && this.cartLength) ret = Number(this.empresa.valorentrega)
			this.cartProducts.map((i) => {
				ret += i.valorTotal
			})
			return ret //ret.toFixed(2).toString().replace('.', ',')
		},
	},
	watch: {
		tipoEntrega() {
			if (this.tipoEntrega == 'Retirar') this.changeEntrega('Retirar')
			else this.changeEntrega('Entrega')
		},
	},
}
</script>
<style scoped>
.textTotais {
	font-weight: bold;
	font-size: 19px;
	letter-spacing: 2px;
	margin: 0px;
	margin-top: 1rem;
}
.textEntrega {
	font-weight: bold;
	font-size: 19px;
	letter-spacing: 2px;
	margin: 0px;
}
.textCarrinho {
	font-weight: bold;
	font-size: 19px;
	align-self: end;
}
.textCarrinhoQuantidade {
	align-items: center;
}
.textPagamentos {
	margin: 0px 0px;
}
.textPagamentosTotal {
	font-weight: 900;
	font-size: 17px;
	margin: 0px;

	margin-bottom: 1rem;
}
.textDescricaoProduto {
	font-size: 19px;
	font-weight: bold;
	margin: 0px;
}
.textMarcaProduto {
	font-weight: bold;
	font-size: 15px;
	margin: 0px;
}
.textValorItem {
	font-weight: 900;
	font-size: 15px;
	margin: 0px;
}
.textValorItemTitulo {
	font-size: 15px;
	margin: 0px;
}
.buttonFinalizarCompra {
	color: white;
}
.buttonAdicionarItens,
.buttonAdicionarEndereco {
	color: var(--v-primary-base);
}
.imgSize {
	max-width: 85px;
	max-height: 85px;
}

.radioButton >>> .v-label.theme--light {
	color: black;
}

.radioButton >>> .theme--light.v-icon {
	color: black;
}
</style>